import Site from "../../../model/site/Site";
import {SitesMap} from "../../reducer/site/SiteState";

/**
 * Create site successful action.
 */
export const SITE_CREATED = "SITE_CREATED";
export type SITE_CREATED = { site: Site };

/** 
 * Sites fetched action.
 */
export const SITES_FETCHED = "SITES_FETCHED";
export type SITES_FETCHED = { sites: SitesMap };

/**
 * Site fetched action.
 */
export const SITE_FETCHED = "SITE_FETCHED";
export type SITE_FETCHED = { site: Site };

/**
 * Sites fetched action.
 */
export const APPOINTMENTS_SITE_FETCHED = "APPOINTMENTS_SITE_FETCHED";
export type APPOINTMENTS_SITE_FETCHED = { sites: SitesMap };